// extracted by mini-css-extract-plugin
module.exports = {"board_table_wrapper":"BoardTable_board_table_wrapper__2vHHD"};